export default __webpack_public_path__ + "static/media/030_corner1.first.d6d84228.png";